module.exports = __webpack_public_path__ + "static/media/arrows-without-fluctuations.62ccd06d.svg";